module.exports = __webpack_public_path__ + "img/icon_dw.04431c18.png";